import * as types from "../consts";
import { CreateProductReducer } from "../interfaces/index";

const initState = {
  isCreateProductOk: false,
};

export default function createProductReducer(
  state = initState,
  action: CreateProductReducer
) {
  switch (action.type) {
    case types.POST_CREATE_PRODUCT_REQUEST: {
      return { ...state, isCreateProductOk: false };
    }
    case types.POST_CREATE_PRODUCT_SUCCESS: {
      return {
        ...state,
        createproduct: action.product,
        isCreateProductOk: true,
      };
    }
    case types.POST_CREATE_PRODUCT_ERROR: {
      return { ...state };
    }

    default: {
      return { ...state };
    }
  }
}
